import { useState } from 'react';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { useListDetailsContext } from '../../contexts/listDetails';
import { QueryBuilderSectionWrapper } from './QueryBuilderSection.styles';
import { QueryBuilder } from './QueryBuilder';
import { PAGE_VARIATIONS } from '../../constants';
import { QueryBuilderHeader } from './QueryBuilderHeader';
import { FilterUsersFurtherHeader } from './FilterUsersFurtherHeader';

export const testIds = {
  togglableQueryBuilderSection: 'togglable-query-builder-section',
};

export const QueryBuilderSection = () => {
  const { pageVariation } = useListDetailsContext();
  const [shouldShowQueryBuilder, setShouldShowQueryBuilder] = useState(false);
  if (pageVariation === PAGE_VARIATIONS.STATIC) {
    return (
      <QueryBuilderSectionWrapper
        data-header-collapsed={!shouldShowQueryBuilder}
        data-test={testIds.togglableQueryBuilderSection}
      >
        {shouldShowQueryBuilder ? (
          <QueryBuilderHeader hideQueryBuilder={() => setShouldShowQueryBuilder(false)} />
        ) : (
          <FilterUsersFurtherHeader expandQueryBuilder={() => setShouldShowQueryBuilder(true)} />
        )}
        <CollapsibleContent isCollapsed={!shouldShowQueryBuilder}>
          <QueryBuilder />
        </CollapsibleContent>
      </QueryBuilderSectionWrapper>
    );
  }
  return <QueryBuilder />;
};
